
import { Component, Emit, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import CustomerGroup from '@/mixins/CustomerGroup';
import { SelectItem } from '@/interfaces/components/SelectItem';
import { Venue } from '@/interfaces/models/Venue';
import { InjectionRateSelection } from '@/interfaces/components/InjectionRateSelection';
import { ExternalOrderProvider } from '@/enums/ExternalOrderProvider';
import VRangePicker from '@/components/shared/form/VRangePicker.vue';

@Component({
  components: { VRangePicker },
})
export default class InjectionRateFilter extends mixins(CustomerGroup) {
  @Prop({ type: Array, default: () => [] }) public venues!: Venue[];

  public selectedVenue: string | null = null;
  public selectedCustomerGroup: string | null = null;
  public selectedProvider: string | null = null;
  public range: { from: string; to: string } = { from: '', to: '' };

  get selection(): InjectionRateSelection {
    return {
      venue: this.selectedVenue || null,
      customerGroup: this.selectedCustomerGroup || null,
      externalOrderProvider: this.selectedProvider || null,
      from: this.range.from,
      to: this.range.to,
    };
  }

  get scopedCustomerGroups() {
    if (this.$isAdmin()) {
      return this.customerGroups;
    }
    if (this.$hasCustomerGroup()) {
      return this.customerGroups.filter((i: SelectItem) => i.value === '' || i.value === this.$getCustomerGroup());
    }

    return [];
  }

  get providers(): SelectItem[] {
    return Object.values(ExternalOrderProvider).map((value: string) => ({
      text: this.$t(`injectionRates.providers.${value}`) as string,
      value,
    }));
  }

  @Emit('change')
  public apply(): InjectionRateSelection {
    return this.selection;
  }

  @Emit('change')
  public reset(): InjectionRateSelection {
    this.selectedVenue = null;
    this.selectedCustomerGroup = null;
    this.selectedProvider = null;

    return this.selection;
  }
}
